import { ReactNode } from 'react';
import styled from 'styled-components';

interface CheckboxWrapperProps {
  children?: ReactNode;
}

export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  display: flex;
  padding: 8px 0;
`;
